<app-header [selectedMenu]="MENU_PAGE.LOANWORD"></app-header>

<div class="container">

  <div class="wrapper">

    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>


  </div>

  <!-- app-footer></app-footer -->

</div>
